import BannerComponent from "@/components/banner/main-banner.vue";
import CyapssApplicationsComponent from "@/components/cyapss-applications/cyapss-applications.component.vue";
import IntroductionComponent from "@/components/cyapss-introduction/cyapss-introduction.component.vue";
import CyapssTestimonialsComponent from "@/components/cyapss-testimonials/cyapss-testimonials.component.vue";
import MoreInformation from "@/components/more-information/more-information.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "home-page",
  components: {
    BannerComponent,
    IntroductionComponent,
    CyapssApplicationsComponent,
    CyapssTestimonialsComponent,
    MoreInformation,
  },
})
export default class HomePage extends Vue {}
